import { playSeatClick } from "./audio";
import { useHallStore, type Phase } from "./store";

export const PHASE_DUR = {
  mixing: 1.5,
  dropping: 0.95,
  calling: 2.7,
  seating: 1.45,
} as const;

export const phaseTime = { t: 0, phase: "idle" as string, advanced: false, started: 0 };

export function resetPhaseClock(phase: string) {
  phaseTime.phase = phase;
  phaseTime.t = 0;
  phaseTime.started = performance.now();
  phaseTime.advanced = false;
}

export function advancePhase(phase: Phase) {
  const store = useHallStore.getState();
  if (store.phase !== phase) return;
  if (phase === "mixing") store.setPhase("dropping");
  else if (phase === "dropping") store.setPhase("calling");
  else if (phase === "calling") store.setPhase("seating");
  else if (phase === "seating") {
    store.addTrauma(0.22);
    if (store.soundEnabled) playSeatClick();
    store.completeSeat();
  }
}

export function tickPhase(_dt: number, phase: Phase) {
  if (phase === "idle" || phase === "celebrating") return;
  const store = useHallStore.getState();
  if (store.phase !== phase) return;
  if (phaseTime.phase !== phase) resetPhaseClock(phase);
  const dur = phase === "mixing" ? store.mixSeconds || PHASE_DUR.mixing : PHASE_DUR[phase as keyof typeof PHASE_DUR];
  if (dur == null) return;
  phaseTime.t = (performance.now() - phaseTime.started) / 1000;
  if (phaseTime.t < dur || phaseTime.advanced) return;
  phaseTime.advanced = true;
  advancePhase(phase);
}
